<template>
  <div class="m-shipping-methods-company-delivery mt-6">
    <div class="mb-2">
      {{ $t('homeDeliveryChooseAddress', 'Vælg leveringsadresse') }}
    </div>

    <base-radio
      v-model="deliveryAddress"
      name="DeliveryAddress"
      class="py-3"
      value="DefaultAddressDelivery"
      @input="useDefaultAddressSelected"
    >
      <template v-slot:label>
        <div class="a-radio__label row">
          <div class="col-12 col-md-6">
            {{ hasAccountShippingAddress ? $t('companyDevlieryDefaultAddress', 'Send til leveringsadressen') : $t('companyDevlieryBillingAddress', 'Send til faktueringsadressen') }}
          </div>
        </div>
      </template>
    </base-radio>

    <base-radio
      v-model="deliveryAddress"
      name="DeliveryAddress"
      class="py-3"
      value="AnotherAddress"
    >
      <template v-slot:label>
        <div class="a-radio__label row">
          <div class="col-12 col-md-6">
            {{ $t('companyDeliveryAnotherAddress', 'Send til en anden adresse') }}
          </div>
        </div>
      </template>
    </base-radio>

    <div v-if="hasAccountShippingAddress && !isAnotherAddressSelected" class="m-shipping-methods-company-delivery__address-container bg-primary-light mt-4 mb-6">
      <address class="mb-0">
        {{ accountShippingAddress.fullName.split('{split}')[0] }} <br>
        {{ accountShippingAddress.fullName.split('{split}')[1] }} <br v-if="$isNotNullOrUndefined(accountShippingAddress.fullName.split('{split}')[1])">
        {{ accountShippingAddress.address }} <br>
        {{ accountShippingAddress.zipCode }}, {{ accountShippingAddress.city }}
      </address>
    </div>

    <address-form
      v-if="isAnotherAddressSelected"
      v-model="value"
      class="mt-4"
      :display-name-input="true"
      :validation-scope="validationScope"
      @update-field="shippingAddressChanged"
    />
  </div>
</template>

<script>
import BaseRadio from '@/components/atoms/BaseRadio.vue';
import AddressForm from '@/components/molecules/ShopCommerce/AddressForm.vue';

export default {
  name: 'ShippingMethodsCompanyDelivery',
  inject: ['$validator'],
  components: {
    BaseRadio,
    AddressForm
  },
  props: {
    value: {
      type: Object,
      required: true
    },
    accountShippingAddress: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      deliveryAddress: 'DefaultAddressDelivery',
      validationScope: 'shipping',
    }
  },
  computed: {
    isAnotherAddressSelected () {
      return this.deliveryAddress === 'AnotherAddress';
    },
    hasAccountShippingAddress () {
      return (
        this.accountShippingAddress?.fullName !== '' &&
        this.accountShippingAddress?.address !== '' &&
        this.accountShippingAddress?.zipCode !== '' &&
        this.accountShippingAddress?.city !== ''
      )
    }
  },
  watch: {
    isAnotherAddressSelected (newValue) {
      this.$emit('reset-shipping-address');
      this.$emit('update-is-another-address-selected', newValue);
    }
  },
  created () {
    this.useDefaultAddressSelected();
  },
  methods: {
    updateField (fieldName, fieldValue) {

      this.$emit('input', {
        ...this.value,
        [fieldName]: fieldValue,
      });
    },
    useDefaultAddressSelected () {
      this.$emit('reset-shipping-address');
      this.$emit('update-shipping-address', true);
    },
    shippingAddressChanged (fieldName, fieldValue) {
      this.updateField(fieldName, fieldValue);
      this.$emit('update-shipping-address');
    }
  }
}
</script>
